import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserBalance } from 'core/types';

export const resetBalances = createAsyncThunk<UserBalance[], void>(
  'balances/resetBalances',
  async () => {
    return [];
  }
);
